module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_5.35fd66c6.png";